import { render, staticRenderFns } from "./FormSugarCentrifugue.vue?vue&type=template&id=353016c5&scoped=true&"
import script from "./FormSugarCentrifugue.vue?vue&type=script&lang=js&"
export * from "./FormSugarCentrifugue.vue?vue&type=script&lang=js&"
import style0 from "./FormSugarCentrifugue.vue?vue&type=style&index=0&id=353016c5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353016c5",
  null
  
)

export default component.exports